// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st1[data-v-710de3ca] {\n  fill: #a1e7fc;\n}\n.st4[data-v-710de3ca] {\n  fill: #eee;\n}\n.st6[data-v-710de3ca] {\n  fill: #f2f2f2;\n}\n.st10[data-v-710de3ca] {\n  fill: #23286b;\n}\n.st12[data-v-710de3ca] {\n  opacity: 0.51;\n  fill: #fff;\n  enable-background: new;\n}\n.st17[data-v-710de3ca] {\n  fill: #1A7BEE;\n}\n.st19[data-v-710de3ca] {\n  opacity: 0.86;\n  fill: #fff;\n  enable-background: new;\n}\n.st24[data-v-710de3ca] {\n  fill: #e94a47;\n}\n", ""]);
// Exports
module.exports = exports;
